import { trpc } from "../trpc";

export const usePricingPlans = () => {
  const { data, isLoading, isPending } = trpc.account.pricingPlans.useQuery();

  return {
    pricingPlans: data,
    isLoading,
    isPending,
  };
};
